import "./MGProgressBar.css"

export default function MGProgressBar({
    totalSteps,
    currentStep,
    color = "#FF6600",
    backgroundColor = "#E5E5E5",
    height = 8
}) {
    const progress = Math.min(
        Math.max((currentStep / totalSteps) * 100, 0),
        100
    );

    return (
        <div
            className="MGProgressBar-progress-bar"
            style={{
                backgroundColor,
                height: `${height}px`
            }}
        >
            <div
                className="MGProgressBar-progress-bar__progress"
                style={{
                    width: `${progress}%`,
                    backgroundColor: color
                }}
            />
        </div>
    );
}